import { Offcanvas } from 'bootstrap';

export default function initOffcanvasNav() {
    const offcanvasElement = document.getElementById('offcanvasNavbar');

    if (!offcanvasElement) {
        return;
    }

    // Get the Bootstrap offcanvas instance
    const offcanvasInstance = Offcanvas.getOrCreateInstance(offcanvasElement);

    // Helper function to properly close offcanvas and remove backdrop
    const closeOffcanvas = () => {
        offcanvasInstance.hide();

        // Remove backdrop manually after a short delay to ensure it's gone
        setTimeout(() => {
            const backdrop = document.querySelector('.offcanvas-backdrop');
            if (backdrop) {
                backdrop.remove();
            }
            document.body.classList.remove('offcanvas-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }, 50);
    };

    // Close offcanvas when actual language links are clicked (not the toggle button)
    offcanvasElement.addEventListener('click', (e) => {
        // Only close if clicking an actual language link (with href), not the dropdown toggle
        const languageLink = e.target.closest('a[hreflang]');

        if (languageLink && languageLink.href) {
            closeOffcanvas();
        }
    });

    // Also close offcanvas when any navigation link is clicked
    const navLinks = offcanvasElement.querySelectorAll('.nav-link:not(.dropdown-toggle)');
    navLinks.forEach(link => {
        link.addEventListener('click', () => {
            closeOffcanvas();
        });
    });
}